import React, { useState } from 'react';

import { Modal, useModal } from "src/components/Modal/Modal";
import ContextMenu from "src/components/ContextMenu/ContextMenu";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./AddOnsTab.module.scss";
import EditAddon from "../../../components/EditAddon";

interface CustomTransactionCellRendererProps extends CustomCellRendererProps {
  deleteAddOn(id: string): void,
  getEventAddOns(): void
}

enum ModalType {
  EDIT = 'edit'
}

export const ActionsRenderer = (props: CustomTransactionCellRendererProps) => {
  const { isShown, toggle } = useModal();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [modalType, setModalType] = useState<ModalType>(ModalType.EDIT);

  return (<div className={styles.ActionRenderer}>
    <ContextMenu
      options={[
        { 
          label: "Delete Add-On",
          onClick:() => {
            props.deleteAddOn(props.data.actions.addon._id);
          }
        },
        {
          label: "Edit Add-On",
          onClick:() => {
            setModalType(ModalType.EDIT);
            toggle();
          }
        }
      ]}
    />
    <Modal
      className={"editAddonModal"}
      isShown={isShown}
      hide={() => { toggle(); }}
      modalContent={
        <EditAddon
          addon={props.value.addon}
          eventId={props.value.event._id}
          onFinish={() => {
            toggle();
            props.getEventAddOns();
          }}
          onCancel={() => {
            toggle();
          }}
        />
      }
    />
  </div>);
};
